<template>
  <div class="footer">
    <div class="container pc">
      <div class="firend-link">
        <ul class="l">
          <li class="one">关于我们</li>
          <li><a href="http://www.cswef.org">中国社会福利基金会</a></li>
          <li><a href="https://www.dongfeng-nissan.com.cn">东风日产</a></li>
          <li><a href="http://infzm.com">南方周末</a></li>
        </ul>
        <!-- <ul class="l">
          <li class="one">友情链接</li>
          <li><a href="http://www.southcn.com">南方报业传媒集团</a></li>
          <li><a href="https://www.ximalaya.com">喜马拉雅FM</a></li>
          <li><a href="">中国科学院物理研究所</a></li>
          <li><a href="http://www.nfpeople.com">南方人物周刊</a></li>
          <li><a href="">南方网</a></li>
          <li><a href="http://www.oeeee.com">南方都市报</a></li>
        </ul> -->
        <ul class="l">
          <li class="one">关于活动</li>
          <li>
            <a href="https://www.sunlove-iread.com/about">阳光关爱·i读计划</a>
          </li>
          <li>
            <a href="https://www.sunlove-iread.com/volunteer">成为志愿者</a>
          </li>
          <!-- <li><a href="">听听名人推荐</a></li> -->
          <li>
            <a
              href="https://s.weibo.com/weibo?q=%23%E9%98%B3%E5%85%89%E5%85%B3%E7%88%B1%C2%B7i%E8%AF%BB%E8%AE%A1%E5%88%92%23"
              >加入微博话题讨论</a
            >
          </li>
        </ul>
        <ul class="l visible-xs">
          <li class="one">关注我们</li>
        </ul>
        <div class="qlink">
          <div class="flex">
            <div class="qr">
              <div>
                <a href=""><img src="../../assets/img/qr.png"/></a>
              </div>
              <p>中国社会福利基金会<br />（cswf4150）</p>
            </div>
            <div class="qr">
              <div>
                <a href=""><img src="../../assets/img/qr2.png"/></a>
              </div>
              <p>东风日产<br />（dongfengrichanauto）</p>
            </div>
            <div class="qr">
              <div>
                <a href=""><img src="../../assets/img/qr3.png"/></a>
              </div>
              <p>南方周末<br />（southernweekly）</p>
            </div>
          </div>
        </div>
      </div>
      <div class="copy">
        &copy;广东南方周末经营有限公司版权所有<br />
         <a href="https://beian.miit.gov.cn/">粤ICP备19134219号</a>
      </div>
    </div>
    <div class="container-full mobile">
      <div
        class="firend-link"
        id="accordion"
        role="tablist"
        aria-multiselectable="true"
      >
        <ul class="l">
          <li class="one" role="tab" id="heading1"  data-toggle="collapse"
              data-parent="#accordion"
              href="#collapse1"
              aria-expanded="true"
              aria-controls="collapse1">
            关于我们
            <i
              class="glyphicon glyphicon-plus "
             
            ></i>
          </li>
          <li
            id="collapse1"
            class="panel-collapse collapse "
            role="tabpanel"
            aria-labelledby="heading1"
          >
            <a href="http://www.cswef.org">中国社会福利基金会</a>
            <a href="https://www.dongfeng-nissan.com.cn">东风日产</a>
            <a href="http://infzm.com">南方周末</a>
          </li>
        </ul>
        <!-- <ul class="l">
          <li class="one" role="tab" id="heading2"  data-toggle="collapse"
              data-parent="#accordion"
              href="#collapse2"
              aria-expanded="false"
              aria-controls="collapse2">
            友情链接
            <i
              class="glyphicon glyphicon-plus "
             
            ></i>
          </li>
          <li
            id="collapse2"
            class="panel-collapse collapse"
            role="tabpanel"
            aria-labelledby="heading2"
          >
            <a href="http://www.southcn.com">南方报业传媒集团</a>
            <a href="https://www.ximalaya.com">喜马拉雅FM</a>
            <a href="">中国科学院物理研究所</a>
            <a href="http://www.nfpeople.com">南方人物周刊</a>
            <a href="">南方网</a>
            <a href="http://www.oeeee.com">南方都市报</a>
          </li>
        </ul> -->
        <ul class="l">
          <li class="one" role="tab" id="heading3" data-toggle="collapse"
              data-parent="#accordion"
              href="#collapse3"
              aria-expanded="false"
              aria-controls="collapse3">
            关于活动
            <i
              class="glyphicon glyphicon-plus "
              
            ></i>
          </li>
          <li
            class="panel-collapse collapse"
            id="collapse3"
            role="tabpanel"
            aria-labelledby="collapse3"
          >
            <a href="https://www.sunlove-iread.com/about">阳光关爱·i读计划</a>
            <a href="https://www.sunlove-iread.com/volunteer">成为志愿者</a>
            <a
              href="https://s.weibo.com/weibo?q=%23%E9%98%B3%E5%85%89%E5%85%B3%E7%88%B1%C2%B7i%E8%AF%BB%E8%AE%A1%E5%88%92%23"
              >加入微博话题讨论</a
            >
          </li>
        </ul>
        <ul class="l ">
          <li class="one">关注我们</li>
        </ul>
        <ul class="l qrul">
          <li class="one" role="tab" id="heading4"  data-toggle="collapse"
              data-parent="#accordion"
              href="#collapse4"
              aria-expanded="false"
              aria-controls="collapse4">
            中国社会福利基金会（cswf4150）
            <i
              class="glyphicon glyphicon-plus "
             
            ></i>
          </li>
          <li
            class="panel-collapse collapse qrcode"
            id="collapse4"
            role="tabpanel"
            aria-labelledby="collapse4"
          >
            <img src="../../assets/img/qr.png" />
          </li>
        </ul>
        <ul class="l qrul">
          <li class="one" role="tab" id="heading5"  data-toggle="collapse"
              data-parent="#accordion"
              href="#collapse5"
              aria-expanded="false"
              aria-controls="collapse5">
            东风日产（dongfengrichanauto）<i
              class="glyphicon glyphicon-plus "
             
            ></i>
          </li>
          <li
            class="panel-collapse collapse qrcode"
            id="collapse5"
            role="tabpanel"
            aria-labelledby="collapse5"
          >
            <img src="../../assets/img/qr2.png" />
          </li>
        </ul>
        <ul class="l qrul">
          <li class="one" role="tab" id="heading6"  data-toggle="collapse"
              data-parent="#accordion"
              href="#collapse6"
              aria-expanded="false"
              aria-controls="collapse6">
            南方周末（southernweekly）
            <i
              class="glyphicon glyphicon-plus "
             
            ></i>
          </li>
          <li
            class="panel-collapse collapse qrcode"
            id="collapse6"
            role="tabpanel"
            aria-labelledby="collapse6"
          >
            <img src="../../assets/img/qr3.png" />
          </li>
        </ul>
       
      </div>
      <div class="copy">
        &copy; 广东南方周末经营有限公司版权所有<br />
        <a href="https://beian.miit.gov.cn/">粤ICP备19134219号</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created() {},
  mounted() {
    $("#accordion").on("hide.bs.collapse show.bs.collapse", function(e) {
      var $this = $(this);
      // console.log($(e.target));
      $(e.target)
        .parent()
        .find("i")
        .toggleClass("glyphicon-plus");
      $(e.target)
        .parent()
        .find("i")
        .toggleClass("glyphicon-minus");
    });
  }
};
</script>
<style lang="less">
.pc {
    display:  block;
  }
  .mobile {
    display: none;
  }
.footer {
  background: #333333;
  padding: 50px 0;
 
  ul.l {
    flex: 1 0 180px;
    list-style-type: none;
    li {
      padding-bottom: 11px;
      text-indent: 10px;
      &.one {
        text-indent: 0;
        font-size: 20px;
        font-weight: 600;
        line-height: 36px;
        color: #fff;
        opacity: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      a {
        font-size: 18px;
        color: #a5a5a5;
      }
    }
  }
}
.firend-link {
  max-width: 1600px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  //   flex-direction: row;
  flex-wrap: wrap;
}

.qlink {
  flex: 1 2 500px;
  width: 100%;
  text-align: center;
  //max-width: 600px;
  .flex {
    display: flex;
    justify-content: space-around;
    img {
      width: 150px;
    }
    p {
      margin-top: 10px;
      font-size: 18px;
      color: #a5a5a5;
    }
  }
}
.pc {
  display: block;
}
.mobile {
  display: none;
}
.copy {
  border-top: 1px dashed #7d7d7d;
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  padding-top: 20px;
  line-height: 36px;
  a{
 color: rgba(165, 165, 165, 1);
 &:hover{
    color: rgba(165, 165, 165, 1);
 }
  }
  color: rgba(165, 165, 165, 1);
  opacity: 1;
}
@media (max-width: 765px) {
  .copy {
  border-top: none;
  
}
  .pc {
    display: none;
  }
  .mobile {
    display: block;
  }

  .footer {
    padding: 0;
    .container-full {
      padding: 30px;
    }
    ul.l {
      padding: 0;
      flex: auto;
      width: 100%;
      img {
        max-width: 50%;
        display: block;
        margin: 0 auto;
      }
      li {
        
        &.qrcode {
          padding: 0 0 10px;
        }
        text-indent: 20px;
        a {
          display: block;
        }
        &.one {
          border-bottom: 1px dotted #707070;
          margin-bottom: 10px;
          font-size: 14px !important;
          text-indent: 0px;
        }

        a {
          font-size: 12px !important;
          color: #a5a5a5;
          line-height: 24px;
        }
      }
    }
  }
}
.qrul{
  li.one{
    padding-left:20px;
    font-weight: normal !important;
  }
}
.qlink {
  width: 100%;

  //max-width: 600px;
  .flex {
    display: flex;
    justify-content: space-around;
    img {
      width: 100%;
    }
    p {
      font-size: 11px;
    }
    .qr {
      overflow: hidden;
      padding: 10px;
    }
  }
}
</style>